
import { Options, prop, Vue } from "vue-class-component";
import { TabsData } from "./module";

class Props {
  modelValue = prop<string>({
    default: "",
    type: String,
    required: true
  });
  data = prop<Array<TabsData>>({
    default: [],
    type: Array
  });
  rounded = prop<boolean>({
    default: true,
    type: Boolean
  });
  contained = prop<boolean>({
    default: false,
    type: Boolean
  });
  marginBottom = prop<number>({
    default: 8,
    type: Number
  });
  titleSize = prop<number>({
    default: 14,
    type: Number
  });
  gap = prop<number>({
    default: 6,
    type: Number
  });
  marginTop = prop<number>({
    default: 6,
    type: Number
  });
  customClass = prop<string>({
    default: "",
    type: String
  });
  newHeaderLayout = prop<boolean>({
    default: false,
    type: Boolean
  })
}
@Options({ emits: ["change", "update:modelValue"] })
export default class Tabs extends Vue.with(Props) {
  changeTabs(value: string) {
    this.$emit("update:modelValue", value);
    this.$emit("change", value);
  }

  isTabActive(value: string) {
    return value === this.modelValue;
  }

  styles(value: string) {
    if (this.rounded) {
      return `px-4 py-2 border rounded-full ${
        this.isTabActive(value) ? "bg-red-lp-1100" : ""
      }`;
    }
    if (this.contained) {
      return `px-4 py-2 rounded-lg ${
        this.isTabActive(value) ? "bg-red-lp-1100" : ""
      }`;
    }

    return `pt-2 pb-4 ${
      this.isTabActive(value) ? "border-b-2 border-red-lp-100" : ""
    }`;
  }
}
